<template>
  <div class="business-manager-disclaimer">
    <div class="business-manager-disclaimer__main">
      <p v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.WHATSAPP_NAME')"></p>
      <p v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT')"></p>
      <p v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.BM_VERIFICATION')"></p>
    </div>

    <button
      type="button"
      class="business-manager-disclaimer__toggle"
      @click="showDetails = !showDetails"
    >
      <span>{{ toggleLabel }}</span>
      <fluent-icon
        :icon="showDetails ? 'chevron-up' : 'chevron-down'"
        size="16"
      />
    </button>

    <div v-show="showDetails" class="business-manager-disclaimer__details">
      <div class="business-manager-disclaimer__section">
        <h6 v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_GUIDE_TITLE')"></h6>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_GUIDE_BODY') }}</p>

        <div class="business-manager-disclaimer__tips">
          <div class="business-manager-disclaimer__tip">
            <p>
              {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_TITLE') }}
            </p>
            <ul>
              <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI1') }}</li>
              <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI2') }}</li>
              <li>
                {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI3') }}
                <ul>
                  <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI3_SUB1') }}</li>
                </ul>
              </li>
              <li>
                {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI4') }}
                <ul>
                  <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI4_SUB1') }}</li>
                  <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI4_SUB2') }}</li>
                  <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CAN_LI4_SUB3') }}</li>
                </ul>
              </li>
            </ul>
          </div>

          <hr class="business-manager-disclaimer__tip-divider" />

          <div class="business-manager-disclaimer__tip">
            <p>
              {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_TITLE') }}
            </p>
            <ul>
              <li>
                {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_LI1') }}
                <ul>
                  <li>
                    {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_LI1_SUB1') }}
                  </li>
                </ul>
              </li>
              <li>
                {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_LI2') }}
                <ul>
                  <li>
                    {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_LI2_SUB1') }}
                  </li>
                </ul>
              </li>
              <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_LI3') }}</li>
              <li>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_CANNOT_LI4') }}</li>
            </ul>
          </div>

          <hr class="business-manager-disclaimer__tip-divider" />

          <div class="business-manager-disclaimer__tip">
            <p>
              {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_BEST_PRACTICES_TITLE') }}
            </p>
            <ul>
              <li v-for="index in 5" :key="`bp-li-${index}`">
                {{ $t(`INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.DISPLAY_NAME_BEST_PRACTICES_LI${index}`) }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="business-manager-disclaimer__section">
        <h6 v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_INCREASE_TITLE')"></h6>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_INCREASE_BODY') }}</p>
        <p>
          {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_STEP_1') }}
        </p>
        <p>
          {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_STEP_2') }}
        </p>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_STEP_2_BODY') }}</p>
        <p>
          {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_BLOCKERS_TITLE') }}
        </p>
        <ul>
          <li v-for="index in 3" :key="`blocker-li-${index}`">
            {{ $t(`INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.TEMPLATE_LIMIT_BLOCKERS_LI${index}`) }}
          </li>
        </ul>
      </div>

      <div class="business-manager-disclaimer__section">
        <h6
          
          v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.GREEN_BADGE_TITLE')"
        ></h6>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.GREEN_BADGE_BODY') }}</p>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.GREEN_BADGE_NOTE') }}</p>
        <p>
          {{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.GREEN_BADGE_REQUIREMENTS_TITLE') }}
        </p>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.GREEN_BADGE_REQUIREMENTS_INTRO') }}</p>
        <ul>
          <li v-for="index in 4" :key="`badge-req-li-${index}`">
            {{ $t(`INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.GREEN_BADGE_REQUIREMENTS_LI${index}`) }}
          </li>
        </ul>
      </div>

      <div class="business-manager-disclaimer__section">
        <h6
          
          v-dompurify-html="$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.BM_VERIFICATION_DETAILS_TITLE')"
        ></h6>
        <p>{{ $t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.BM_VERIFICATION_DETAILS_BODY') }}</p>
        <div>
          <ul>
            <li v-for="index in 5" :key="`bm-benefit-li-${index}`">
              {{ $t(`INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.BM_VERIFICATION_BENEFITS_LI${index}`) }}
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'QualityDisclaimer',
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    toggleLabel() {
      return this.showDetails
        ? this.$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.HIDE_MORE')
        : this.$t('INBOX_MGMT.BUSINESS_MANAGER.DISCLAIMER.SHOW_MORE');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';

.business-manager-disclaimer {
  width: 100%;
  margin-top: $space-large;
  padding: 3.6rem 3rem;
  background: #E0E0E0;
  border-radius: 10px;

  p{
    white-space: pre-line;
    margin: 0;
  }
}

.business-manager-disclaimer__main {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.business-manager-disclaimer__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $space-micro;
  width: 100%;
  margin: $space-normal auto 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1170C6;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  cursor: pointer;

  &:hover {
    color: var(--w-600);
  }

  &:focus-visible {
    outline: 2px solid #1170C6;
    outline-offset: 2px;
    border-radius: var(--border-radius-small);
  }
}

.business-manager-disclaimer__details {
  max-width: 100%;
  margin-top: $space-large;
  padding-top: $space-large;
}

.business-manager-disclaimer__section {
  margin-bottom: $space-large;

  &:last-child {
    margin-bottom: 0;
  }
}

.business-manager-disclaimer__tips {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: $space-large;
}

.business-manager-disclaimer__tip {
  flex: 1;
}

.business-manager-disclaimer__tip-divider {
  height: auto;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.15);
  border: 0;
  margin: 0;
  flex-shrink: 0;
  align-self: stretch;
}

@media (max-width: 768px) {
  .business-manager-disclaimer__tips {
    flex-direction: column;
    gap: $space-normal;

    .business-manager-disclaimer__tip-divider {
      display: none;
    }
  }
}
</style>
